import React from 'react';
import { Row, Col, Card, Typography, Avatar } from 'antd';
import { motion } from 'framer-motion';
import './Testimonials.css';

import { UserOutlined
} from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const testimonials = [
  {
    name: "Dr. Ahmed Khan",
    position: "Hospital Director, Lahore",
    content: "Prime Healthcare Consultancy guided us perfectly through the PHC accreditation process. We achieved Level 3 accreditation in record time.",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg"
  },
  {
    name: "Dr. Fatima Ali",
    position: "Clinic Administrator, Faisalabad",
    content: "Their quality improvement program transformed our patient care services. Our patient satisfaction scores increased by 40%.",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg"
  },
  
  {
    name: "Mr. Usman Malik",
    position: "Healthcare Group CEO, Multan",
    content: "The staff training programs were exceptional. Our team is now fully compliant with all PHC standards and regulations.",
    avatar: "https://randomuser.me/api/portraits/men/75.jpg"
  }
];

const Testimonials = () => {
  return (
    <div className="testimonials-section" style={{ padding: '50px 0' }}>
      <Title level={2} style={{ textAlign: 'center', marginBottom: '50px' }}>What Our Clients Say</Title>
      <Row gutter={[24, 24]}>
        {testimonials.map((testimonial, index) => (
          <Col xs={24} md={8} key={index}>
            <motion.div
              whileHover={{ scale: 1.03 }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="testimonial-card">
                <Paragraph italic style={{ fontSize: '1.1rem' }}>
                  "{testimonial.content}"
                </Paragraph>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                  <Avatar icon={<UserOutlined />} size={64} />
                  <div style={{ marginLeft: '16px' }}>
                    <Title level={5} style={{ margin: 0 }}>{testimonial.name}</Title>
                    <Paragraph type="secondary" style={{ margin: 0 }}>{testimonial.position}</Paragraph>
                  </div>
                </div>
              </Card>
            </motion.div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Testimonials;